export { default as General } from 'notifications_config/components/form/sections/NotificationConfigFormGeneral';
export { default as Depreciations } from 'notifications_config/components/form/sections/NotificationConfigFormDepreciations';
export { default as Users } from 'notifications_config/components/form/sections/NotificationConfigFormUsers';
export { default as Elements } from 'notifications_config/components/form/sections/NotificationConfigFormElements';
export { default as UsersTable } from 'notifications_config/components/form/sections/NotificationConfigFormUsersTable';
export { default as UserRow } from 'notifications_config/components/form/sections/NotificationConfigFormUserRow';
export { default as UsersToNotifyTable } from 'notifications_config/components/form/sections/NotificationConfigFormUsersToNotifyTable';
export { default as UserToNotifyRow } from 'notifications_config/components/form/sections/NotificationConfigFormUserToNotifyRow';



// WEBPACK FOOTER //
// src/modules/secured/modules/notifications_config/components/form/sections/index.js